import axios from 'axios'

import dartcome from './dartcome'
import ranch from './ranch'

import Store from '@/Store.js'
export default {
  namespaced: true,
  modules: {
    dartcome,
    ranch
  },
  actions: {
    async r ({rootState}, options) {
      if (!options.headers) {
        options.headers = {}
      }
      if (!options.headers['tephra-seesion-id']) {
        let sid = Store.get('sid')
        if (sid) {
          options.headers['tephra-session-id'] = sid
        }
      }
      try {
        let res = await axios.request(options)
        return res
      } catch (e) {
        if (e.response) {
          // The request was made and the server responded with a status code
          // that falls out of the range of 2xx
          return e.response
        }
        if (e.request) {
          // The request was made but no response was received
          // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
          // http.ClientRequest in node.js
          console.error(e.request)
          let msg = `请求失败：网络不稳定，请稍后再试。`
          let moreInfo = [e.message]
          if (rootState.env !== 'prod') {
            msg = `${msg}(${moreInfo.join(', ')})`
          }
          throw new Error(msg)
        }
        console.error(e)
        // Something happened in setting up the request that triggered an Error
        throw e
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/api/index.js